/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Session integrity budget projected on run state (shadow/enforce modes).
 */
export interface OralExamIntegrityBudget {
  consecutiveTechnicalPauseSeconds?: number;
  totalTechnicalPauseSeconds?: number;
  remainingConsecutiveSeconds?: number;
  remainingTotalSeconds?: number;
  wouldVoid?: boolean;
}
